/* tslint:disable */
/* eslint-disable */
/**
 * external-information-requests
 * Medicaid Pending document requests to family members, with the staff workspace and the family portal
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues, parseDate, parseDateTime, serializeDate, serializeDateTime } from '../runtime';
import type { PortalFacility } from './PortalFacility';
import {
    PortalFacilityFromJSON,
    PortalFacilityFromJSONTyped,
    PortalFacilityToJSON,
    PortalFacilityToJSONTyped,
} from './PortalFacility';
import type { ParticipantRelationship } from './ParticipantRelationship';
import {
    ParticipantRelationshipFromJSON,
    ParticipantRelationshipFromJSONTyped,
    ParticipantRelationshipToJSON,
    ParticipantRelationshipToJSONTyped,
} from './ParticipantRelationship';
import type { PortalHelpContact } from './PortalHelpContact';
import {
    PortalHelpContactFromJSON,
    PortalHelpContactFromJSONTyped,
    PortalHelpContactToJSON,
    PortalHelpContactToJSONTyped,
} from './PortalHelpContact';

/**
 * 
 * @export
 * @interface PortalSession
 */
export interface PortalSession {
    /**
     * 
     */
    participant_display_name: string;
    /**
     * 
     */
    relationship: ParticipantRelationship | null;
    /**
     * 
     */
    resident_first_name: string | null;
    /**
     * 
     */
    facility: PortalFacility;
    /**
     * 
     */
    help_contact: PortalHelpContact | null;
    /**
     * Why the documents are needed, shown on the portal home
     */
    purpose_text: string | null;
    /**
     * 
     */
    session_expires_at: Date;
    /**
     * 
     */
    access_expires_at: Date;
    /**
     * 
     */
    last_read_message_id: string | null;
    /**
     * 
     */
    unread_message_count: number;
}



/**
 * Check if a given object implements the PortalSession interface.
 */
export function instanceOfPortalSession(value: object): value is PortalSession {
    if (!('participant_display_name' in value) || value['participant_display_name'] === undefined) return false;
    if (!('relationship' in value) || value['relationship'] === undefined) return false;
    if (!('resident_first_name' in value) || value['resident_first_name'] === undefined) return false;
    if (!('facility' in value) || value['facility'] === undefined) return false;
    if (!('help_contact' in value) || value['help_contact'] === undefined) return false;
    if (!('purpose_text' in value) || value['purpose_text'] === undefined) return false;
    if (!('session_expires_at' in value) || value['session_expires_at'] === undefined) return false;
    if (!('access_expires_at' in value) || value['access_expires_at'] === undefined) return false;
    if (!('last_read_message_id' in value) || value['last_read_message_id'] === undefined) return false;
    if (!('unread_message_count' in value) || value['unread_message_count'] === undefined) return false;
    return true;
}

export function PortalSessionFromJSON(json: any): PortalSession {
    return PortalSessionFromJSONTyped(json, false);
}

export function PortalSessionFromJSONTyped(json: any, ignoreDiscriminator: boolean): PortalSession {
    if (json == null) {
        return json;
    }
    return {
        
        'participant_display_name': json['participant_display_name'],
        'relationship': ParticipantRelationshipFromJSON(json['relationship']),
        'resident_first_name': json['resident_first_name'],
        'facility': PortalFacilityFromJSON(json['facility']),
        'help_contact': PortalHelpContactFromJSON(json['help_contact']),
        'purpose_text': json['purpose_text'],
        'session_expires_at': (json['session_expires_at'] == null ? json['session_expires_at'] : parseDateTime(json['session_expires_at'])),
        'access_expires_at': (json['access_expires_at'] == null ? json['access_expires_at'] : parseDateTime(json['access_expires_at'])),
        'last_read_message_id': json['last_read_message_id'],
        'unread_message_count': json['unread_message_count'],
    };
}

export function PortalSessionToJSON(json: any): PortalSession {
    return PortalSessionToJSONTyped(json, false);
}

export function PortalSessionToJSONTyped(value?: PortalSession | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'participant_display_name': value['participant_display_name'],
        'relationship': ParticipantRelationshipToJSON(value['relationship']),
        'resident_first_name': value['resident_first_name'],
        'facility': PortalFacilityToJSON(value['facility']),
        'help_contact': PortalHelpContactToJSON(value['help_contact']),
        'purpose_text': value['purpose_text'],
        'session_expires_at': value['session_expires_at'] == null ? value['session_expires_at'] : serializeDateTime(value['session_expires_at']),
        'access_expires_at': value['access_expires_at'] == null ? value['access_expires_at'] : serializeDateTime(value['access_expires_at']),
        'last_read_message_id': value['last_read_message_id'],
        'unread_message_count': value['unread_message_count'],
    };
}

